/**
 * 품절 재선택 안내 문구 프리셋.
 *
 * 원칙:
 * - **추측을 쓰지 않는다.** "예상보다 많은 신청으로" 같은 문구는 사실이 아닐 수 있어 쓰지 않는다.
 *   실제 원인은 대부분 ①판매처(스타벅스·던킨 등)가 그 상품을 내렸거나 ②쿠폰 공급사 재고가
 *   소진된 경우다. 둘 중 실제에 맞는 프리셋을 고른다.
 * - 수령자 입장에서는 어떤 이유든 유쾌하지 않으므로 **사과를 앞에 두고, 원인은 담백하게 한 줄,
 *   바로 대안(재선택)**으로 넘어간다. 변명조로 길게 쓰지 않는다.
 * - 기한 고지("○월 ○일까지 선택이 없으시면 상주님께 전액 환불")는 **서버가 항상 덧붙이므로**
 *   본문에 넣지 않는다. (docs/gift-coupon-reselect-soldout-spec.md §6)
 *
 * 첫 줄의 `[답례품 재선택 안내]` 말머리는 LMS 표시용이며, 수령자 웹페이지에서는
 * 대괄호 줄을 떼고 본문만 보여준다.
 */
export interface ReselectNoticePreset {
  id: string;
  /** 관리자용 짧은 이름 (칩 라벨) */
  label: string;
  /** 어떤 상황에 쓰는지 */
  hint: string;
  message: string;
}

const body = (reasonLines: string[]) =>
  [
    '[답례품 재선택 안내]',
    ...reasonLines,
    '',
    '번거롭게 해 드려 죄송합니다.',
    '아래에서 원하시는 상품으로 다시 선택해 주시면',
    '바로 준비해 드리겠습니다.',
  ].join('\n');

export const RESELECT_NOTICE_PRESETS: ReselectNoticePreset[] = [
  {
    id: 'brandDiscontinued',
    label: '교환처 판매 종료',
    hint: '스타벅스·던킨 등 교환처에서 그 상품을 더 이상 팔지 않는 경우',
    message: body(['신청해 주신 상품이 교환처의 판매 종료로 품절되었습니다.']),
  },
  {
    id: 'issuanceStopped',
    label: '쿠폰 발행 중단',
    hint: '교환처는 그대로인데 해당 상품의 쿠폰 발행이 중단된 경우',
    message: body(['신청해 주신 상품이 쿠폰 발행 중단으로 품절되었습니다.']),
  },
  {
    id: 'temporarilyUnavailable',
    label: '일시 품절',
    hint: '재개 시점이 정해지지 않아 기다리기 어려운 경우',
    message: body([
      '신청해 주신 상품이 일시 품절되어',
      '언제 다시 발행될지 알기 어려운 상황입니다.',
    ]),
  },
];

/** 프리셋을 고르지 않았을 때의 기본 본문 (원인을 특정하지 않는 중립 문구) */
export const RESELECT_NOTICE_DEFAULT_MESSAGE = body([
  '신청해 주신 상품이 품절되었습니다.',
]);
